module.exports = __webpack_public_path__ + "media/110390__soundscalpel-com__cartoon-siren-whistle-001.3d819783.mp4";